import { Box } from "@mui/material";
import dayjs from "dayjs";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { harvestActions } from "../../redux/reducer/harvest/harvestReducer";
import { useNavigate } from "react-router-dom";

export default function Day({ day, row, data }) {

  // Navigate
  const navigate = useNavigate();

  // Redux
  const dispatch = useDispatch();

  const getCurrentDayClass = () => {
    return day.format("DD-MM-YY") === dayjs().format("DD-MM-YY");
  };
  const [localeData, setLocaleData] = useState([]);

  useEffect(() => {
    let tempData = [];
    if (day) {
      data.map((item) => {
        if (
          item.plantingDetails.estimatedDate ===
          day.format("YYYY-MM-DD")
        ) {
          tempData.push(item);
        }
      });
      setLocaleData(tempData);
    }
  }, [day]);

  const toHarvestDashboard = () => {
    dispatch(harvestActions.addDashboardData(localeData));
    navigate("/petani/panen/dashboard");
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="space-evenly"
      width="100%"
      height="auto"
    >
      {row === 0 ? (
        <div
          style={{
            color: "rgb(40, 85, 90)",
            fontWeight: "bold",
            fontSize: "17px",
          }}
        >
          {day.format("ddd")}
        </div>
      ) : (
        ""
      )}

      <div
        className={`${getCurrentDayClass()}`}
        style={{
          color: "rgb(36, 79, 90)",
          fontWeight: "bold",
          fontSize: "15px",
          margin: "5px",
        }}
      >
        {day.format("DD")}
      </div>

      <div
        style={{
          width: "100%",
          height: "auto",
          color: "white",
          marginBottom: "10px",
        }}
      >
        {localeData.length > 0 && (
          <div
            className="text-center"
            style={{
              width: "90%",
              margin: "2px auto",
              background: "#0A543B",
              borderRadius: "5px",
              cursor: "pointer",
              textAlign: "center",
            }}
            onClick={() => toHarvestDashboard()}
          >
            {`${localeData.length} Panen`}
          </div>
        )}
      </div>
    </Box>
  );
}

Day.propTypes = {
  data: PropTypes.array,
  day: PropTypes.object,
  row: PropTypes.number,
};
